var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.listClass] },
    [
      _vm._t("errors", null, null, { items: _vm.items }),
      _vm._v(" "),
      _vm._t("filter", null, null, {
        updateFilter: _vm.updateFilter,
        loadItems: _vm.loadItems,
        items: _vm.items,
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "listWrapper",
          staticClass: "list-wrapper",
          style: [{ height: _vm.calculatedHeight }],
        },
        [
          !_vm.isMounted ? _vm._t("default") : _vm._e(),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "events-group-list" },
              _vm._l(_vm.groupedItems, function (group) {
                return _c(
                  "div",
                  {
                    key: "group-" + group.groupDate,
                    staticClass: "events-group-item",
                  },
                  [
                    _c("div", { staticClass: "events-group-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatDate(group.groupDate)) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(group.items, function (item, index) {
                      return _c(
                        "div",
                        { key: "group-item-" + item.eventId + "-" + index },
                        [
                          _vm._t("card-template", null, null, {
                            item: item,
                            key:
                              "card-" +
                              item.eventId +
                              "-group-" +
                              group.groupDate,
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ],
          _vm._v(" "),
          _vm.items.length === 0 ? _vm._t("no-items") : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("pagination", null, null, {
        pagination: _vm.pagination,
        defaultLimit: _vm.defaultLimit,
        allLoaded: _vm.allLoaded,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }